var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',_vm._b({staticClass:"grey lighten-3 pa-3"},'v-layout',_vm.$attrs,false),[_c('recipe-statistic',{attrs:{"value":_vm.recipe.prepareTime,"title":"příprava"}}),_c('recipe-statistic',{attrs:{"value":_vm.recipe.totalTime,"title":"celkový čas"}}),_c('recipe-statistic',{attrs:{"value":_vm.recipe.portions,"title":"porce"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }